// PDFViewer.jsx
import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './PDFViewer.css';

// Configura el worker de PDF.js desde un CDN
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ pdfUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detecta dispositivo móvil mediante el userAgent
  useEffect(() => {
    const mobileCheck = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobile(mobileCheck);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Si el usuario está en móvil, utiliza el visor nativo a través de <object>
  if (isMobile) {
    return (
      <div className="pdf-viewer-container">
        <object
          data={`${pdfUrl}#toolbar=0`}
          type="application/pdf"
          width="100%"
          height="500px"
        >
          <p>
            Tu dispositivo no soporta la visualización de PDFs embebidos. 
            <a href={pdfUrl}>Descárgalo aquí</a>.
          </p>
        </object>
      </div>
    );
  }

  // En escritorio se utiliza react-pdf para renderizar el documento
  return (
    <div className="pdf-viewer-container">
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading="Cargando PDF..."
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={1.0} />
        ))}
      </Document>
    </div>
  );
};

export default PDFViewer;
